export function ProductGallery() {
  return (
    <div className="product-gallery">
      <figure>
        <img src="/product/campaign-builder-landing-qr.png" alt="B4 campaign builder with landing page and QR routing setup" />
        <figcaption>Before launch, teams can see the public page, location scope, embed code, and QR routing in one place.</figcaption>
      </figure>
      <figure>
        <img src="/product/qr-routing-stats.png" alt="B4 campaign builder showing reusable QR code routing statistics" />
        <figcaption>After launch, reusable QR routes keep scan and signup activity tied to the campaign that created them.</figcaption>
      </figure>
    </div>
  );
}
